/**
 * Fix-oriented hints for the row-level error catalog (spec §6.2). The backend
 * `message` states what's wrong; the hint here states what to do about it.
 * Not part of the API contract — the DTO only carries `message`.
 */
const ERROR_HINTS: Record<string, string> = {
  REQUIRED_FIELD_EMPTY: 'Fill in this column and re-upload.',
  INVALID_EMAIL_FORMAT: 'Correct the email address and re-upload.',
  EMAIL_NOT_FOUND: 'Check the email for typos, or confirm the person has a bQuest account.',
  AMBIGUOUS_EMAIL: 'This is a data conflict, not a typo — no CSV edit resolves it.',
  ROLE_MISMATCH: "Set this to the user's actual role shown above.",
  INVALID_ROLE: 'Use one of the accepted role values or aliases from the template.',
  SELF_REFERRAL: "One of the two emails is wrong — they can't be the same person.",
  CARE_SEEKER_XOR_VIOLATED:
    'Fill either care_seeker_email or both new_care_seeker_* names, or leave all four blank — not both.',
  INVITE_WITHOUT_EMAIL: 'Add new_care_seeker_email or clear send_invitation_email.',
  INVITE_ON_EXISTING_CARE_SEEKER: 'Leave send_invitation_email empty — this care seeker already has an account.',
  INVALID_DATE_FORMAT: 'Use MM/DD/YYYY, M/D/YYYY, or YYYY-MM-DD.',
  TWO_DIGIT_YEAR: 'Spell out the full 4-digit year.',
  FUTURE_DATE: 'Use the date the referral actually occurred, not a future date.',
  INVALID_BOOLEAN: 'Use true/false, yes/no, 1/0, or leave the cell empty.',
  TEXT_TOO_LONG: 'Shorten the text to fit the character limit.',
  DUPLICATE_IN_FILE: 'Delete one of the duplicate rows.',
  DUPLICATE_IN_DATABASE: 'This referral was already imported — delete the row.',
  CARE_SEEKER_EMAIL_ALREADY_USER: 'Use care_seeker_email instead — this person already has an account.',
  ON_BEHALF_OF_NOT_PROFESSIONAL:
    'The on-behalf-of party must be a financial advisor or service provider account.',
};

const DEFAULT_HINT = 'Fix this cell in the CSV and re-upload the file.';

export const hintFor = (code: string): string => ERROR_HINTS[code] ?? DEFAULT_HINT;
